export default (val) => {
  return (val / 100).toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
}



// WEBPACK FOOTER //
// ./src/filters/currency.js